import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  @Input()
  id: any;

  @Input()
  label: any;

  @Input()
  name: any;

  @Output()
  onClick? = new EventEmitter<any>();

  @Input()
  checked?: any;

  @Input()
  disabled?: any;

  constructor() {}

  ngOnInit() {}

  onChange(e: any) {
    this.onClick.emit(e);
  }
}
